import { BrowserCacheLocation, InteractionRequiredAuthError, PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { AuthListenerEvent } from "./entities";
import { AuthWebClientEvents } from "./enums";
export class MSALAuthWebClientOptions {
}
export class MSALAuthWebClient {
    constructor(options) {
        this.options = options;
        if (!this.options) {
            throw new Error("MSALAuthWebClientOptions must be provided");
        }
        if (this.options) {
            this.msalAuthClient = new PublicClientApplication({
                auth: {
                    clientId: this.options?.clientId,
                    authority: this.options?.authority,
                    redirectUri: this.options?.redirectUri,
                    postLogoutRedirectUri: this.options?.postLogoutRedirectUri,
                    knownAuthorities: this.options?.knownAuthorities,
                    navigateToLoginRequestUrl: false,
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.LocalStorage,
                },
                system: {
                    allowNativeBroker: false,
                    loggerOptions: {
                        logLevel: LogLevel.Error,
                        piiLoggingEnabled: false,
                    },
                },
            });
        }
    }
    async checkTokenValidity(scopes) {
        await this.msalAuthClient.initialize();
        try {
            const account = this.msalAuthClient.getAllAccounts();
            if (account.length !== 0) {
                var request = {
                    scopes: scopes,
                    account: account[0],
                };
                const response = await this.msalAuthClient.acquireTokenSilent(request);
                window.dispatchEvent(new AuthListenerEvent(AuthWebClientEvents.ES_PATIENT_HUB_AUTH_LISTENER, {
                    detail: {
                        action: 'hasValidToken',
                        payload: response?.accessToken !== undefined ? true : false,
                    }
                }));
                return response?.accessToken;
            }
        }
        catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                console.warn("Interaction required to acquire token:", error);
                return null;
            }
            console.error("Token acquisition failed:", error);
            return null;
        }
    }
    async login(request) {
        try {
            await this.msalAuthClient.initialize();
            await this.msalAuthClient.loginRedirect(request);
        }
        catch (error) {
            console.error("Login error:", error);
        }
    }
    async handleRedirectPromise() {
        await this.msalAuthClient.initialize();
        return this.msalAuthClient.handleRedirectPromise();
    }
    getActiveAccount() {
        return this.msalAuthClient.getActiveAccount();
    }
    setActiveAccount(accInfo) {
        return this.msalAuthClient.setActiveAccount(accInfo);
    }
    getAllAccounts() {
        return this.msalAuthClient.getAllAccounts();
    }
    logout(request) {
        this.msalAuthClient.logoutRedirect(request);
    }
}
//# sourceMappingURL=msal-auth-web-client.js.map